export default __webpack_public_path__ + "static/SRUS RTL120 - Especification Del Producto y Datos Técnicos-a44b86c6aedb72e3e4f5ace85cd387f0.pdf";